/*!
 * Created by netlogix GmbH & Co. KG.
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Action } from '@ngrx/store';
import { Appointment } from '@shared/models/appointment';

export const LOAD_APPOINTMENTS = '[Appointments] Load appointments';
export const LOAD_APPOINTMENTS_FAILURE = '[Appointments] Load appointments failure';
export const LOAD_APPOINTMENTS_SUCCESS = '[Appointments] Load appointments success';
export const LOAD_APPOINTMENT = '[Appointments] Load appointment';
export const LOAD_APPOINTMENT_SUCCESS = '[Appointments] Load appointment success';
export const LOAD_APPOINTMENT_FAILURE = '[Appointments] Load appointment failure';
export const PERSIST_APPOINTMENT = '[Appointments] Persist';
export const PERSIST_APPOINTMENT_FAILURE = '[Appointments] Persist failure';
export const PERSIST_APPOINTMENT_SUCCESS = '[Appointments] Persist success';
export const DELETE_APPOINTMENT = '[Appointments] Delete';
export const DELETE_APPOINTMENT_FAILURE = '[Appointments] Delete failure';
export const DELETE_APPOINTMENT_SUCCESS = '[Appointments] Delete success';

export class LoadAppointments implements Action {
  readonly type = LOAD_APPOINTMENTS;
}

export class LoadAppointmentsFailure implements Action {
  readonly type = LOAD_APPOINTMENTS_FAILURE;
}

export class LoadAppointmentsSuccess implements Action {
  readonly type = LOAD_APPOINTMENTS_SUCCESS;
  constructor(public appointments: Appointment[]) { }
}

export class LoadAppointment implements Action {
  readonly type = LOAD_APPOINTMENT;
  constructor(public appointmentId?: string) { }
}

export class LoadAppointmentSuccess implements Action {
  readonly type = LOAD_APPOINTMENT_SUCCESS;
  constructor(public appointment: Appointment) { }
}

export class LoadAppointmentFailure implements Action {
  readonly type = LOAD_APPOINTMENT_FAILURE;
}

export class PersistAppointment implements Action {
  readonly type = PERSIST_APPOINTMENT;
  constructor(public appointment: Appointment) { }
}

export class PersistAppointmentFailure implements Action {
  readonly type = PERSIST_APPOINTMENT_FAILURE;
}

export class PersistAppointmentSuccess implements Action {
  readonly type = PERSIST_APPOINTMENT_SUCCESS;
  constructor(public appointment: Appointment) { }
}

export class DeleteAppointment implements Action {
  readonly type = DELETE_APPOINTMENT;
  constructor(public appointmentId: string) { }
}

export class DeleteAppointmentFailure implements Action {
  readonly type = DELETE_APPOINTMENT_FAILURE;
}

export class DeleteAppointmentSuccess implements Action {
  readonly type = DELETE_APPOINTMENT_SUCCESS;
}

export type AppointmentActions = LoadAppointments | LoadAppointmentsFailure | LoadAppointmentsSuccess | LoadAppointment |
  LoadAppointmentSuccess | LoadAppointmentFailure | PersistAppointment | PersistAppointmentFailure | PersistAppointmentSuccess |
  DeleteAppointment | DeleteAppointmentFailure | DeleteAppointmentSuccess;
